// @ts-nocheck

import { BetCategories } from '../types/bet';

export const BetCategoriesForMatchFilters = [
  BetCategories.SCORERS_SOCCER,
  BetCategories.SCORERS_BASKETBALL,
  BetCategories.SCORERS_RUGBY,
];
